








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { MortgageRateDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxMortgageRateType extends Vue {
  private types: MortgageRateDto[] | null = [];
  public selectedType = new MortgageRateDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: MortgageRateDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: MortgageRateDto) {
    this.$emit("mortgageRateTypeSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .mortgageRate_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
